export enum AllowedAdminUsernames {
  ANAS = 'anas',
  ADMIN = 'admin',
  ABDULKARIM = 'abdulkarim',
  RAKAN = 'rakan@recyclee.io',
}

export enum ReadOnlyAdminUsernames {}

export interface LoginRequest {
    username?: string;
    phone?: string;
    password: string;
}

export interface LoginResponse {
    access_token: string;
    refresh_token: string;
}

export interface RefreshTokenRequest {
    refresh_token: string;
}

export interface RegisterRequest {
    username: string;
    password: string;
    password_confirm: string;
    data: UserData;
}

export interface UserData {
    permissions?: string[] | Record<string, string[]>;
    sites?: Record<string, string[]> | null;
    onesignal_player_id?: string;
    first_name?: string | null;
    last_name?: string | null;
    full_name?: string | null;
    [key: string]: unknown;
}

export interface UserSchema {
    id?: string;
    sub: string;
    username: string;
    phone?: string | null;
    full_name?: string | null;
    email?: string;
    data?: UserData;
    created_at?: string;
    updated_at?: string;
    exp?: number;
    iat?: number;
}

export interface UpdateUserRequest {
    username?: string | null;
    data?: Partial<UserData> | null;
}

export interface ForgotPasswordRequest {
    username: string;
    platform: 'ESG';
}

export interface ResetPasswordRequest {
    token: string;
    new_password: string;
    new_password_confirm: string;
}

/** JWT access token payload — permissions at root after PR2 migration. */
export interface AuthTokenPayload {
    sub: string;
    username: string;
    typ: string;
    exp: number;
    iat: number;
    permissions: string[] | Record<string, string[]>;
    platform_permissions?: string[];
    sites?: Record<string, string[]>;
    is_pilot?: boolean;
}
